import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {
  toggleSelectionWindow, toggleSelectionFeatureInfo, changeActivePartRelatedItemIndex, setCameFromPage, setQtActiveCategory
} from "../../actions/actionFunctions";
import CommonFeatureItemsMethods from "../visComponents/commonFeatureItemsMethods";
import {featureThumbnailUrl, toFixedFeatureCost} from "../../misc/helpers";
import {THUMBNAIL_SIZES} from "../../misc/utils";
import FeatureName from "../visComponents/featureName";
import {getPriceWithIncluded} from "../../misc/priceFunctions";

class RecentlyViewedItems extends CommonFeatureItemsMethods {

  componentDidMount() {
    // const recentlyList = document.querySelector(".recently");
    // const recentlyListHeight = recentlyList && recentlyList.clientHeight - 30;
    // if (recentlyListHeight) {
      // const columnsCount = (this.props.windowWidth <= 680) ? 2 : 3;
      // const rowNumber = Math.ceil(this.props.recentlyItems.length/columnsCount);
    // }
  }


  static propTypes = {
    isMobile: PropTypes.bool,
    recentlyItems: PropTypes.array.isRequired
  };

  renderEmptyItems = () => {
    const emptyItems = [];
    const recentlyItems = this.props.recentlyItems;
    const featuresLength = recentlyItems.length;
    const minItems = (window.innerWidth <= 680)
      ? 6
      : (window.innerHeight <= 300)
        ? (featuresLength <= 6) ? 6 : 9
        : 9;
    if ((featuresLength < minItems) && (this.props.windowWidth <= 991)) {
      for (let i = 1; i <= minItems - featuresLength;i++) {
        emptyItems.push(
          <li className="recently-list__item recently-list__item--empty" key={"empty"+i} />
        )
      }
    }
    return emptyItems
  };

  render() {
    const {fabricatorData, intl} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    return (
      <div className={"recently" + (this.props.isMobile ? " recently--mobile" : "")}>
        {this.props.isMobile ? (
          <h4 className={"recently-title"}>
            <FormattedMessage id="shoppingCart.recentlyViewedItemsTitle"/>
          </h4>
        ) : null}
        {/*<h4 className={"recently-title"}>Would you like to add any of these items to your cart?</h4>*/}
        <ul className="recently-list">
          {this.props.recentlyItems.map((cartItem, index) => {

            let showPrice = false;
            if (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser) {
              if ((fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !cartItem.cartFeature.dbFeature.unlocked) {
                if (this.props.isPhoneNumberValidated) {
                  showPrice = true
                }
              } else {
                showPrice = true
              }
            }
            const priceIsLocked = !this.props.isPhoneNumberValidated && (fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
              && fabricatorSettings.showPricing && !cartItem.cartFeature.dbFeature.unlocked;

            const style = {
              backgroundImage: `url(${featureThumbnailUrl(cartItem.cartFeature, THUMBNAIL_SIZES.medium)})`
            };
            const price = toFixedFeatureCost(cartItem.cartFeature, 1);
            return (
              <li className="recently-list__item" key={cartItem.cartFeature.partName+index} style={style}
                  onClick={() => this.switchToFeatureInfo(cartItem.cartFeature, 'recently-viewed-switch-to-feature-info', "", null, cartItem)}>
                <div className="recently-list__item-text">
                  <FeatureName feature={cartItem.cartFeature}/>
                  {this.props.isMobile && showPrice
                    ? <span>{getPriceWithIncluded(price, cartItem.cartFeature, fabricatorData, intl.messages)}</span>
                    : null}
                  {this.props.isMobile && priceIsLocked ? (
                    <span className="price--locked">
                      <FormattedMessage id="shoppingCart.featurePriceLocked"/>
                    </span>
                  ) : null}
                </div>
              </li>
            )
          })}
          {this.renderEmptyItems().map(emptyItem => emptyItem)}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  changeActivePartRelatedItemIndex,
  setCameFromPage,
  setQtActiveCategory
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RecentlyViewedItems)
)
